import { render, staticRenderFns } from "./MileageDetail.vue?vue&type=template&id=242c7497"
import script from "./MileageDetail.vue?vue&type=script&lang=js"
export * from "./MileageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports